import MobileDetect from 'mobile-detect';

const md = (typeof window !== 'undefined')
  ? new MobileDetect(window.navigator.userAgent)
  : null;

export const onWaypoint = {
  methods: {
    onWaypoint({ el, going }) {
      if (going === this.$waypointMap.GOING_IN) {
        el.classList.add('fade');
      }
    },
  },
};

export const isOpenedPopup = {
  methods: {
    isOpenedPopup(flag) {
      if (flag) {
        document.body.classList.add('-opened-menu');
        document.documentElement.classList.add('-opened-menu');
      } else {
        document.body.classList.remove('-opened-menu');
        document.documentElement.classList.remove('-opened-menu');
      }
    },
  },
};


export const parallax = {
  mounted() {
    if (md && !md.mobile()) {
      import('jarallax').then(({ jarallax, jarallaxElement }) => {
        jarallaxElement(document.querySelectorAll('.jarallax'));
        jarallax(document.querySelectorAll('.jarallax'));
      });
    }
  },
};



// WEBPACK FOOTER //
// ./src/mixins.js